import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
*{
    margin: 0;
    padding: 0;
}
body{

    font-family:'Poppins', sans-serif;
    background: #f2f2f2;
    
}
`;
